import { render } from "./ItemConfirm.vue?vue&type=template&id=5f90715a&scoped=true&ts=true"
import script from "./ItemConfirm.vue?vue&type=script&lang=ts"
export * from "./ItemConfirm.vue?vue&type=script&lang=ts"

import "./ItemConfirm.vue?vue&type=style&index=0&id=5f90715a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f90715a"]])

export default __exports__